import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PackageService } from '../../services/package-service/package-service';

export interface PricingPlan {
  title: string;
  price: string;
  features: string[];
  cta: string;
  route: string;
  isVariable?: boolean;
  note?: string;
  queryParams?: unknown; // ✅ added
}

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [CommonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pricing.html',
})
export class Pricing implements OnInit {
  private readonly router = inject(Router);
  private readonly packageService = inject(PackageService);

  pricingPlans: PricingPlan[] = [];

  ngOnInit(): void {
    this.pricingPlans = this.packageService.getAllPackages();
  }

  navigate(plan: PricingPlan): void {
    if (plan.cta === 'Get Started') {
      this.router.navigate([plan.route], {
        queryParams: plan.queryParams || {}
      });
    } else {
      this.router.navigate([plan.route]);
    }
  }
}